import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import type { TFunction } from "i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import type { LmsCourseContentValues } from "@/components/lms/lms.utils";
import styles from "@/routes/lms/lmsCourseOverview.module.css";

interface Props {
  canEditTranslations: boolean;
  content: LmsCourseContentValues;
  onEditTranslations: () => void;
  t: TFunction;
}

export default function LmsCourseContentSection({
  canEditTranslations,
  content,
  onEditTranslations,
  t,
}: Props) {
  return (
    <section className={styles.settingsPanel}>
      <div className={styles.settingsSectionHeader}>
        <h2>{t("course_content_section")}</h2>
      </div>

      <div className={styles.courseContentNotice} role="note">
        <p>{t("course_content_translation_notice")}</p>
        {canEditTranslations && (
          <GenericButton
            variant="outlined"
            startIcon={<LanguageOutlinedIcon fontSize="small" />}
            onClick={onEditTranslations}
          >
            {t("edit_course_translations")}
          </GenericButton>
        )}
      </div>

      <div className={styles.courseContentDisplay}>
        <h3
          className={styles.courseContentTitle}
          data-testid="course-content-title"
        >
          {content.title || "-"}
        </h3>
        {content.description ? (
          <div
            className={styles.courseContentDescription}
            data-testid="course-content-description"
            dangerouslySetInnerHTML={{ __html: content.description }}
          />
        ) : (
          <p
            className={styles.courseContentDescription}
            data-testid="course-content-description"
          >
            -
          </p>
        )}
      </div>
    </section>
  );
}
